import React, { useMemo } from "react";
import { Modal, Button, Table } from "react-bootstrap";
import PageLoading from "components/PageLoading";
import { FaCheckCircle } from "react-icons/fa";
import { sortHistoricoDocumentacaoDesc } from "utils/date";
import "./DocumentationHistory.css";

type HistoryEntry = {
  acao: string;
  data: string;
  id?: number;
};

type DocumentationHistoryProps = {
  show: boolean;
  onHide: () => void;
  historyData: HistoryEntry[];
  loading?: boolean;
};

const DocumentationHistory = ({
  show,
  onHide,
  historyData,
  loading = false,
}: DocumentationHistoryProps) => {
  const historyOrdenado = useMemo(
    () => sortHistoricoDocumentacaoDesc(historyData || []),
    [historyData],
  );

  return (
    <Modal show={show} onHide={onHide} centered className="doc-history-modal">
      <Modal.Header closeButton>
        <Modal.Title className="modal-title">
          HISTÓRICO DA DOCUMENTAÇÃO
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="doc-history-modal-scroll-pane doc-history-modal-scroll-pane--center">
            <PageLoading minHeight="200px" message="Carregando histórico..." />
          </div>
        ) : historyOrdenado.length === 0 ? (
          <div className="doc-history-modal-scroll-pane doc-history-modal-scroll-pane--center text-center py-3">
            <p className="mb-0">Nenhum histórico encontrado.</p>
          </div>
        ) : (
          <div className="doc-history-modal-scroll-pane">
            <Table bordered className="doc-history-table mb-0">
              <thead>
                <tr>
                  <th>AÇÃO</th>
                  <th>DATA/HORA</th>
                </tr>
              </thead>
              <tbody>
                {historyOrdenado.map((item, index) => (
                  <tr
                    key={
                      item.id != null
                        ? `h-${String(item.id)}`
                        : `${item.acao}-${item.data}-${index}`
                    }
                  >
                    <td>
                      <FaCheckCircle className="icon-check" />{" "}
                      {item.acao}
                    </td>
                    <td>{item.data}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}

        <div className="doc-history-modal-footer text-center">
          <Button className="btn-ok" onClick={onHide}>
            OK
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DocumentationHistory;
